import { Bounds } from "../engine/space/bounds";
import {
  bound,
  boundsAreSame,
  ComponentO,
  isOver,
  KeyEvents,
  MouseEvents,
} from "./ui";

function findMouseHandlers(
  ui: ComponentO,
  eventType: keyof MouseEvents,
  pos: [number, number]
) {
  const handlers: (() => void)[] = [];
  const findHandlers = (com: ComponentO, o?: Bounds) => {
    const b = o ? bound(o, com.bounds) : com.bounds;
    if (isOver(pos, b)) {
      if (com.handlers[eventType] != null) {
        handlers.push(com.handlers[eventType]!);
      }
      com.getChildren().forEach((c) => findHandlers(c, b));
    }
  };
  findHandlers(ui);
  return handlers;
}

export function handleMouseEvent(
  ui: ComponentO,
  eventType: keyof MouseEvents,
  pos: [number, number]
) {
  const handlers = findMouseHandlers(ui, eventType, pos);
  if (handlers.length) {
    handlers[handlers.length - 1]();
  }
}

function getHovered(ui: ComponentO, pos: [number, number]) {
  const elements: ComponentO[] = [];
  const findHovered = (com: ComponentO, o?: Bounds) => {
    const b = o ? bound(o, com.bounds) : com.bounds;
    if (isOver(pos, b)) {
      elements.push(com);
      const children = com.getChildren();
      if (children) {
        children.forEach((c) => findHovered(c, b));
      }
    }
  };
  findHovered(ui);
  return elements;
}

let hoveredTiles: ComponentO[] = [];
let selectedTile: [number, number];

export function handleHover(ui: ComponentO, pos: [number, number]) {
  if (
    !selectedTile ||
    pos[0] !== selectedTile[0] ||
    pos[1] !== selectedTile[1]
  ) {
    const hovered = getHovered(ui, pos);
    const over = hovered.filter(
      (el) =>
        !hoveredTiles.find(
          (t) => t.type === el.type && boundsAreSame(el.bounds, t.bounds)
        )
    );

    const out = hoveredTiles.filter(
      (el) =>
        !hovered.find(
          (t) => t.type === el.type && boundsAreSame(el.bounds, t.bounds)
        )
    );
    over.forEach((el) => {
      if (el.handlers.hover) {
        el.handlers.hover();
      }
    });
    out.forEach((el) => {
      if (el.handlers.out) {
        el.handlers.out();
      }
    });

    hoveredTiles = hovered;
  }
}

function findKeyHandlers(ui: ComponentO, eventType: keyof KeyEvents) {
  const handlers: ((key: string, shift: boolean) => boolean)[] = [];
  const findHandlers = (com: ComponentO) => {
    if (com.handlers[eventType] != null) {
      handlers.push(com.handlers[eventType]!);
    }
    com.getChildren().forEach((c) => findHandlers(c));
  };
  findHandlers(ui);
  return handlers;
}

export function handleKeyEvent(
  ui: ComponentO,
  eventType: keyof KeyEvents,
  key: string,
  shift: boolean
) {
  const handlers = findKeyHandlers(ui, eventType);
  if (handlers.length) {
    for (let i = handlers.length - 1; 0 <= i; i--) {
      if (handlers[i](key, shift)) {
        return;
      }
    }
  }
}
